<aig-cookies *ngIf="cookies" (closeCookies)="close($event)"></aig-cookies>

<aig-header></aig-header>
<main class="main">
  <router-outlet />
</main>
<aig-footer></aig-footer>
